import React from "react";
import {MotifIcon, MotifBreadcrumb, MotifBreadcrumbItem} from "@ey-xd/motif-react";
import { folderIcon } from '../../common/MotifIcons';
import FolderZippedIcon from "../../common/images/Folder_Zippediconbreadscrumb.svg";

const BreadcrumbNavigation = ({ currentPath, goBack, isClientEngagement }) => {    
    return (
        <MotifBreadcrumb>
            {/* Default Home Link */}
            <MotifBreadcrumbItem>
                <a className="cursor-pointer" onClick={() => goBack(-1)}>
               {isClientEngagement?"Client Data & EY Owned Data Files":"EY Owned Data Files"}
                </a>
            </MotifBreadcrumbItem>

            {/* Dynamic Breadcrumb Navigation */}
            {currentPath.map((folder, index) => {
                const isZip = folder.toLowerCase().endsWith(".zip");
                return (
                    <MotifBreadcrumbItem key={index}>
                         <>
                        {
                        isZip ? (
                            <img
                                loading="lazy"
                                className="zippedIconBreadcrumb"
                                src={FolderZippedIcon}
                                alt="ZIP file icon"
                            />
                        ) : (
                            <MotifIcon src={folderIcon} />
                        )}

                        {index === currentPath.length - 1 ? (
                            <span className="text-gray-500">{folder.replace(".zip", "")}</span>
                        ) : (
                            <a className="cursor-pointer" onClick={() => goBack(index)}>
                                {folder.replace(".zip", "")}
                            </a>
                        )}
                        </>
                    </MotifBreadcrumbItem>
                );
            })}
        </MotifBreadcrumb>
    );
};

export default BreadcrumbNavigation;
